import { NotificationPermissionType } from 'app/area/user-profile/my-notifications/types';

export const getNotificationPermission = (): NotificationPermissionType => {

  const permissionType = 'Notification' in window && window.Notification.permission;

  if (!['default', 'denied', 'granted'].includes(permissionType)) {
    return NotificationPermissionType.NotSupported;
  } else {
    if (permissionType === 'granted') {
      return NotificationPermissionType.Granted;
    } else {
      return permissionType === 'denied' ? NotificationPermissionType.Denied : NotificationPermissionType.Unknown;
    }
  }
};
